import React from "react";
import styles from "./CustomHeader.module.scss";
import Button from "../Button/Button";
import PlusIcon from "../SVGComponents/PlusIcon";
import SearchBox from "../SearchBox/SearchBox";

interface CustomHeaderProps {
  search?: string | null;
  setSearch?: React.Dispatch<React.SetStateAction<string | null>>;
  buttonLabel?: string;
  onButtonClick?: () => void;
}
const CustomHeader: React.FC<CustomHeaderProps> = ({
  search,
  setSearch,
  buttonLabel,
  onButtonClick,
}) => {
  return (
    <div className={styles.topSection}>
      <div className={styles.filterSearch}>
        <SearchBox
          value={search ?? ""}
          onChange={(val) => setSearch?.(val)}
          placeholder="Search..."
          onFilterClick={() => {}}
        />
      </div>
      {onButtonClick && (
        <Button
          onClick={onButtonClick}
          className={styles.button}
          outlined={false}
        >
          <PlusIcon className={styles.plusicon} />
          {buttonLabel}
        </Button>
      )}
    </div>
  );
};

export default CustomHeader;
